import React, { Component } from 'react';

export default class LogoZBorder extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }
    }

    componentDidMount() { }

    componentWillReceiveProps() { }

    render() {

        return (

            <svg style={this.props.style} className={this.props.className} xmlns='http://www.w3.org/2000/svg' viewBox='230 115 540 540'>
                <path d='M249.6,131.8v500h500v-500H249.6z M734.6,616.8h-470v-470h470V616.8z' />
                <path d='M659.6,451.8H501.7l0,0l-23.1,15h166v60v0h-286l0,0l301-195.4V221.8h-320v90h305v9v0L354.6,509v-66 l179.1-116.2h-31.4v0L339.6,432.4v109.4h320V451.8z M354.6,296.8v-60v0h290v0v60H354.6z' />
            </svg>
        );
    }
}